import styled from "styled-components";

const StyledFooter = styled.footer`
  background: #484848;

  {/* from bootstrap 5.0*/}
  &.p-3 {
    padding: 1rem !important;
  }
  .text-center {
    text-align: center !important;
  }
  .text-white {
    color: #fff !important;
  }

`;

export default StyledFooter;